import React from "react";
import { Row, Column } from "@appcues/component-library";

import ProfilePanel from "./ProfilePanel";
import AccountAPIKeysPanel from "./AccountAPIKeysPanel";
import AccountSettingsPanel from "./AccountSettingsPanel";
import FrequencyCappingPanel from "./FrequencyCappingPanel";
import CustomerSupportPanel from "./CustomerSupportPanel";

const AccountPage = () => (
  <Row setChildrenEqualSize marginTop={0}>
    <Column>
      <ProfilePanel />
      <AccountAPIKeysPanel />
      <CustomerSupportPanel />
    </Column>
    <Column>
      <AccountSettingsPanel />
      <FrequencyCappingPanel />
    </Column>
  </Row>
);

export default AccountPage;
